<app-main-toolbar/>

<div class="pg-content">
  <router-outlet/>
</div>


<footer #footer>
  GUIDOZORN ADMIN v.{{version}}
</footer>